import React, { useState } from "react";
import "./ProductsShowcase.css";

import ebookImage from "../../assets/images/brand-logos/ebook_yarife.webp";
import decor1 from "../../assets/images/icons/Recurso 67.png";
import decor2 from "../../assets/images/icons/Recurso 68.png";

const ProductsShowcase = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handleVideoClick = (e) => {
    setIsVideoPlaying(true);
    e.stopPropagation();
  };

  return (
    <section id="guaybo" className="guaybo-section">
      <div className="guaybo-container">
        {/* Imágenes decorativas */}
        <img
          src={decor2}
          alt=""
          className="guaybo-decor guaybo-decor--top-left"
        />

        <div className="guaybo-content">
          <h2 className="guaybo-title">APRENDE CON YARIFE</h2>
          <p className="guaybo-sub ">
            LIBERA TU POTENCIAL <span className="accent">CREATIVO</span> CON MI{" "}
            <span className="purple-text">CURSO COMPLETO</span> +{" "}
            <span className="purple-text">EBOOK</span> PARA LLEVAR TUS
            PRESENTACIONES A OTRO NIVEL
          </p>

          <div className="guaybo-grid">
            {/* Imágenes decorativas */}
            <img
              src={decor1}
              alt=""
              className="guaybo-decor guaybo-decor--top-right"
            />
            <img
              src={decor1}
              alt=""
              className="guaybo-decor guaybo-decor--bottom-left"
            />
            {/* Card del curso */}
            <div
              className="guaybo-card course"
              onClick={() =>
                window.open(
                  "https://www.guaybo.com/yarifepower/crea-una-presentacion-con-canva-desde-cero-1",
                  "_blank"
                )
              }
            >
              <div className="card-header">
                <div className="card-thumbnail">
                  {!isVideoPlaying ? (
                    <img
                      src="https://img.youtube.com/vi/Bu0-5FIjJPk/maxresdefault.jpg"
                      alt="Curso Canva desde cero"
                      className="youtube-thumbnail"
                      onClick={handleVideoClick}
                    />
                  ) : (
                    <div className="video-container">
                      <iframe
                        src="https://www.youtube.com/embed/Bu0-5FIjJPk?autoplay=1&rel=0"
                        title="Curso Canva desde cero"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="youtube-video"
                      ></iframe>
                      <button
                        className="close-video"
                        onClick={() => setIsVideoPlaying(false)}
                        aria-label="Cerrar video"
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="card-content">
                <h3 className="card-title">
                  Crea una presentación con Canva desde cero
                </h3>

                <div className="card-features">
                  <h4>Características:</h4>
                  <p>
                    Aprende a diseñar desde la estructura hasta los elementos
                    gráficos
                  </p>
                </div>

                <div className="card-actions">
                  <button className="cta">Ver curso</button>
                  <div className="price">$7,00</div>
                </div>
              </div>
            </div>

            {/* Card del ebook */}
            <div
              className="guaybo-card ebook"
              onClick={() =>
                window.open(
                  "https://www.guaybo.com/yarifepower/ebook-aprende-a-disenar-presentaciones-efectivas-y-atractivas",
                  "_blank"
                )
              }
            >
              <div className="card-header">
                <div className="card-thumbnail">
                  <img
                    src={ebookImage}
                    alt="Ebook presentaciones efectivas"
                    className="ebook-image"
                  />
                </div>
              </div>
              <div className="card-content">
                <h3 className="card-title">
                  Aprende a diseñar presentaciones efectivas y atractivas
                </h3>

                <div className="card-features">
                  <h4>Características:</h4>
                  <p>
                    Atrapa a tus espectadores o convence a tu cliente creando
                    una presentación con un contenido potente y un diseño
                    atractivo.
                  </p>
                </div>

                <div className="card-actions">
                  <button className="cta">Ver Ebook</button>
                  <div className="price">$12,00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsShowcase;
